import { useEffect, useState, useRef } from "react";
import { Modal } from "../Modal";
import { NavButton } from "../NavButton";
import './index.scss';
import FontSizeAdjuster from "../FontSizeAdjuster";
import TextSizeSlider from "../TextSizeSlider";

declare global {
  interface Window {
    VLibras?: any;
  }
}

export const MenuAcessibilidade = ({ ModoAcessivel, OnPress, acessivel }) => {
  const [baixaVisao, setBaixaVisao] = useState(false);
  // Inicializa o estado do VLibras dependendo se ele está aberto ou não
  const [libras, setLibras] = useState(() => {
    const isOpen = !!document.querySelector('[vw-plugin-wrapper].active');
    return isOpen;
  });
  const [modoNoturno, setModoNoturno] = useState(false);
  const [sliderTexto, setMudarTexto] = useState(false);
  const [sliderCores, setMudarCores] = useState(false);
  const [tempUm, setTempUM] = useState(false);
  const [tempDois, setTempDois] = useState(false);
  const [hoveredTitle, setHoveredTitle] = useState("");

  const toggleVLibras = () => {
   const accessBtn = document.querySelector('body > div.VLibras > div.active') as HTMLElement;
    const closeBtn = document.querySelector("#VLIBRAS > div > div.vpw-box > div.vpw-settings-btn > div:nth-child(2) > button.vpw-header-btn-close") as HTMLElement;
    const painel = document.querySelector("#VLIBRAS")
    const isOpen = painel? window.getComputedStyle(painel).display !=="none" : false
      if (accessBtn  && !isOpen) {
        accessBtn.click();
      }
  }


  // Adiciona/remove classes no body para diferentes temas
  useEffect(() => {
    const body = document.body;

    if (baixaVisao) {
      body.classList.add('baixaVisao');
    } else {
      body.classList.remove('baixaVisao');
    }

    if (modoNoturno) {
      body.classList.add('darkMode');
    } else {
      body.classList.remove('darkMode');
    }

    if (tempUm) {
      body.classList.add('newPalette');
    } else {
      body.classList.remove('newPalette');
    }

    if (tempDois) {
      body.classList.add('temaTrilogic');
      body.classList.remove('darkMode');
      body.classList.remove('newPalette');
      body.classList.remove('baixaVisao');
    } else {
      body.classList.remove('temaTrilogic');
    }
  }, [baixaVisao, modoNoturno, tempDois, tempUm]);

  return (
    <Modal content="" showModal={true} onPress={OnPress}>
      <h2>{sliderCores ? "" : sliderTexto ? "ALTERAR TAMANHO DO TEXTO" : "MENU ACESSIBILIDADE"}</h2>
      {sliderTexto && <TextSizeSlider />}
      {sliderCores && <FontSizeAdjuster />}

      {!sliderCores && !sliderTexto && (
        <div className="acessibilidade-nav-container">
          <div className="acessibilidade-nav-buttons">
            <NavButton
              title="Conteúdo em imagens"
              icon="image"
              onClick={ModoAcessivel}
              modoAtivado={acessivel}
              //style={{ position: "relative", transform: "scale(3)" }}
              onMouseEnter={() => setHoveredTitle("Conteúdo Módulo 1 em imagens")}
              onMouseLeave={() => setHoveredTitle("")}
            />
            <NavButton
              title="Ativar VLibras"
              icon="sign_language"
              onClick={toggleVLibras}
              modoAtivado={libras}
              //style={{ position: "relative", transform: "scale(3)" }}
              onMouseEnter={() => setHoveredTitle("Abrir/Fechar o VLibras")}
              onMouseLeave={() => setHoveredTitle("")}
            />
            <NavButton
              title="Modo Noturno"
              icon="nightlight"
              onClick={() => setModoNoturno(!modoNoturno)}
              modoAtivado={modoNoturno}
              //style={{ position: "relative", transform: "scale(3)" }}
              onMouseEnter={() => setHoveredTitle("Ativar/Desativar o Modo Noturno")}
              onMouseLeave={() => setHoveredTitle("")}
            />
            <NavButton
              title="Alto Contraste"
              icon="visibility"
              onClick={() => setBaixaVisao(!baixaVisao)}
              modoAtivado={baixaVisao}
              //style={{ position: "relative", transform: "scale(3)" }}
              onMouseEnter={() => setHoveredTitle("Ativar/Desativar o Modo Alto Contraste")}
              onMouseLeave={() => setHoveredTitle("")}
            />
            <NavButton
              title="Mudar tamanho do texto"
              icon="text_increase"
              onClick={() => setMudarTexto(!sliderTexto)}
              modoAtivado={sliderTexto}
              //style={{ position: "relative", transform: "scale(3)" }}
              onMouseEnter={() => setHoveredTitle("Modificar o tamanho do texto")}
              onMouseLeave={() => setHoveredTitle("")}
            />
            <NavButton
              title="Mudar Cores"
              icon="palette"
              onClick={() => setMudarCores(!sliderCores)}
              modoAtivado={sliderCores}
              //style={{ position: "relative", transform: "scale(3)" }}
              onMouseEnter={() => setHoveredTitle("Alterar as cores do site")}
              onMouseLeave={() => setHoveredTitle("")}
            />
          </div>
        </div>

      )}
      <div className="acessibilidade-hovered-title">
        {!sliderTexto && !sliderCores && <span>{hoveredTitle}</span>}
      </div>

    </Modal>
  );
};